<nav #navbarSize
    class="navbar navbar-expand-lg navbar-light custom-layer justify-content-end bg-white-pure"
    id="navbar">
  <div class="parent-content">
    <ng-content></ng-content>
  </div>
  <div *ngIf="showNotificationToggle"
      class="background-blur">
  </div>
  <div class="col-auto px-0 align-items-center"
      (clickOutside)="closeNotification()">
    <button class="btn btn-notification d-flex"
        title="{{ 'NAV-BAR.NOTIFICATION' | translate }}"
        type="button"
        (click)="openNotification()">
      <div class="noti-center">
        <svg-icon [svgClass]="'icon-size-res'"
            [src]="'assets/svg/icon-menu/' +  (isNotificationUnread ? 'noti-red.svg' :'noti.svg')"
            aria-hidden="true">
        </svg-icon>
      </div>
    </button>
    <div class="row w-100 justify-content-end me-4">
      <div *ngIf="showNotificationToggle"
          class="width-box"
          (scrollingFinished)="loadMoreNotification()"
          appScrollTracker
          @showHideNotification>
        <div class="p-0">
          <div class="d-flex justify-content-between align-items-center border-bottom-custom p-3">
            <h6 class="m-0 headerText-custom fw-bold"
                [style.color]="'#12141F'">
              {{ 'NAV-BAR.NOTIFICATION'|translate }}
            </h6>
            <button type="button"
                class="btn-close"
                aria-label="Close"
                (click)="closeNotification()">
            </button>
          </div>
          <div class="d-flex flex-wrap gap-2 text-start my-2 p-3">
            <button class="btn round-input box-btn-notification "
                type="button"
                [ngClass]="unread  ? 'btn-std-outline' : 'btn-std-prim'"
                (click)="filterUnreadNotification(null)">
              {{ 'NAV-BAR.All'|translate }}
            </button>
            <button class="btn round-input box-btn-notification"
                type="button"
                [ngClass]="unread  ? 'btn-std-prim' : 'btn-std-outline'"
                (click)="filterUnreadNotification(true)">
              {{ 'NAV-BAR.Unread'|translate }}
            </button>
          </div>
          <div class="text-start pt-2">
            <label *ngIf="notificationThisWeek?.results.length"
                class="ps-3 fw-bold text-black">
              {{ 'NAV-BAR.This week'|translate }}
            </label>
            <div class="row mx-0 px-1 py-3 height-box pointer col-12 position-relative align-items-center"
                *ngFor="let notification of notificationThisWeek?.results"
                [ngClass]="{'bg-unread': !notification.read}"
                (click)="clickNotification(notification)">
              <div class="col-auto p-0 d-flex align-items-start mx-3 mt-2"
                  [ngClass]="{'opacity-50': notification.read}">
                <app-profile-display *ngIf="notification?.notification?.actor"
                    [person]="notification?.notification?.actor"
                    [size]="48"></app-profile-display>
                <img *ngIf="!notification?.notification?.actor"
                    src="assets/images/flaticons/bell-notification.png"
                    class="photo-actor">
              </div>
              <div class="col p-0 text-start">
                <p class="custom-box-detail fs-l2"
                    [ngStyle]="{'color': notification.read ? '#9DA0AB' : ''}"
                    [innerHTML]="translateSidebar.currentLang === 'th'? notification.content: notification.content_en">
                </p>
                <span>
                  <a class="text-time fs-l4"
                      [ngStyle]="{'color': notification.read ? '#9DA0AB' : ''}">
                    {{ notification.notification.time_since[translateSidebar.currentLang] }}
                  </a>
                </span>
              </div>
              <div class="col-auto p-0 d-flex align-items-start mx-3">
                <div [ngClass]="notification.read ? '':'status-circle'">
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="notificationResult?.results.length"
              class="text-start pt-4">
            <label class="ps-3 fw-bold text-black">
              {{ 'NAV-BAR.All-time'|translate }}
            </label>
            <div class="row mx-0 px-1 py-3 height-box pointer col-12 position-relative align-items-center"
                *ngFor="let notification of notificationResult?.results"
                [ngClass]="{'bg-unread': !notification.read}"
                (click)="clickNotification(notification)">
              <div class="col-auto p-0 d-flex align-items-start mx-3 mt-2"
                  [ngClass]="{'opacity-50': notification.read}">
                <app-profile-display *ngIf="notification?.notification?.actor"
                    [person]="notification?.notification?.actor"
                    [size]="48"></app-profile-display>
                <img *ngIf="!notification?.notification?.actor"
                    src="assets/images/flaticons/bell-notification.png"
                    class="photo-actor">
              </div>
              <div class="col p-0 text-start">
                <p class="custom-box-detail fs-l2"
                    [ngStyle]="{'color': notification.read ? '#9DA0AB' : ''}"
                    [innerHTML]="translateSidebar.currentLang === 'th'? notification.content: notification.content_en">
                </p>
                <span>
                  <a class="text-time fs-l4"
                      [ngStyle]="{'color': notification.read ? '#9DA0AB' : ''}">
                    {{ notification.notification.time_since[translateSidebar.currentLang] }}
                  </a>
                </span>
              </div>
              <div class="col-auto p-0 d-flex align-items-start mx-3">
                <div [ngClass]="notification.read ? '':'status-circle'">
                </div>
              </div>
            </div>
          </div>

          <div class="w-100"
              style="margin: 5px">
            <app-loading-spinner [loading]="isLoading"></app-loading-spinner>
          </div>
        </div>

        <div class="border-top-custom text-start footer-width-box">
          <a class="text-std-color-3"
              href="javascript:void(0)"
              (click)="markAllAsRead()">{{ "NAV-BAR.MARK-ALL-AS-READ"|translate }}</a>
        </div>
      </div>
    </div>
  </div>
  <app-lang-selector class="d-none d-md-inline-block mx-2"
      [style]="'dropdown'"></app-lang-selector>
  <div class="col-auto col-auto pe-lg-0 profile-border me-4">
    <div class="text-white d-flex align-items-center"
        ngbDropdown
        display="dynamic">
      <div class="d-none d-md-inline ms-1 me-2">
        <label class="d-block fw-semibold text-black-pantone mb-0">
          {{ profile?.shorted_name }}
        </label>
        <label class="d-block pointer text-end fw-normal fs-base-l4 text-gray-pantone mb-0"
            (click)="logOut()">{{ "SIDEBAR.LOGOUT" | translate }}
        </label>
      </div>
      <div *ngIf="profile"
          class="d-none d-md-inline">
        <app-profile-display [person]="profile"
            [size]="35"
            [pointer]="true"
            (clickProfile)="navigateToProfile()"></app-profile-display>
      </div>
    </div>
  </div>
</nav>

<ng-template #backgroundTaskModalTemp>
  <app-modal-confirmation-std-mobile-header
      [hideButton]="true"
      [header]="'APPROVAL.MULTI-APPROVE.Action details summary' | translate"
      (dismiss)="closeBackgroundTaskModal()"
      (submitted)="closeBackgroundTaskModal()">
    <ng-template>
      <ng-template #tileTemp
        let-background="background"
        let-foreground="foreground"
        let-statusIconPathUrl="statusIconPathUrl"
        let-title="title"
        let-count="count">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <div class="title-icon"
                [style.background-color]="background">
              <svg class="icon-status"
                  viewBox="0 0 18 18"
                  width="25"
                  height="25">
                <circle cx="50%"
                    cy="50%"
                    r="8"
                    [attr.fill]="background"/>
                <use width="12"
                    height="12"
                    x="3"
                    y="3"
                    [attr.href]="statusIconPathUrl"
                    [style.stroke]="foreground">
                </use>
              </svg>
            </div>
            <div class="ms-u0 fw-medium">
              {{ title | translate }}
            </div>
          </div>
          <div class="text-gray-silver-sand-mid">
            {{ count }} {{ 'APPROVAL.MULTI-APPROVE.memos' | translate }}
          </div>
        </div>
      </ng-template>
      <ng-template #detailListTemp
        let-background="background"
        let-foreground="foreground"
        let-rows="rows">
        <div class="detail-wrapper p-u0 mt-l8"
            [style.background-color]="background">
          <div class="d-flex align-items-center mb-u0"
              *ngFor="let row of rows">
            <div class="dot-separator"
                [style.background-color]="foreground"></div>
            <div [style.color]="foreground">{{ row }}</div>
          </div>
        </div>
      </ng-template>
      <div style="max-height: 60vh; overflow-y: auto;">
      <ng-container *ngIf="hasSuccessRows">
        <ng-container [ngTemplateOutlet]="tileTemp"
            [ngTemplateOutletContext]="{
            background: statusColors.approved?.background,
            foreground: statusColors.approved?.foreground,
            statusIconPathUrl: 'assets/images/icons/marks/circle-check.svg#circle-check',
            title: 'APPROVAL.MULTI-APPROVE.Action complete',
            count: backgroundTask?.success_s11_document_numbers?.length}">
        </ng-container>
        <ng-container [ngTemplateOutlet]="detailListTemp"
            [ngTemplateOutletContext]="{
            background: statusColors.approved?.background,
            foreground: statusColors.approved?.foreground,
            rows: backgroundTask?.success_s11_document_numbers || []}">
        </ng-container>
      </ng-container>
      <ng-container *ngIf="hasFailedRows">
        <div *ngIf="hasSuccessRows && hasFailedRows"
            class="my-u8 w-100">
          <hr>
        </div>
        <ng-container [ngTemplateOutlet]="tileTemp"
            [ngTemplateOutletContext]="{
            background: statusColors.terminated?.background,
            foreground: statusColors.terminated?.foreground,
            statusIconPathUrl: 'assets/images/icons/accessibility/info-circle.svg#info-circle',
            title: 'APPROVAL.MULTI-APPROVE.Error',
            count: backgroundTask?.failure_s11_document_numbers?.length}">
        </ng-container>
        <ng-container [ngTemplateOutlet]="detailListTemp"
            [ngTemplateOutletContext]="{
            background: statusColors.terminated?.background,
            foreground: statusColors.terminated?.foreground,
            rows: backgroundTask?.failure_s11_document_numbers || []}">
        </ng-container>
      </ng-container>
      </div>
    </ng-template>
  </app-modal-confirmation-std-mobile-header>
</ng-template>